import { useMenuStore } from '@/stores/menu'
import { useAuthStore } from '@/stores/auth'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import checkVersion from './versionCheck';
import { MenuItem } from '@/models/MenuItem';

const homeGuard = async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const menuStore = useMenuStore()
  const authStore = useAuthStore()

  if(authStore.VLtoken){
    try {
      await checkVersion();
    } finally {
      await menuStore.getMenuItems()
      const home = menuStore.homePage;
      menuStore.currentItem = home as MenuItem;
      if (home?.Embed) {
        next(`/embed/${home.ID}`)
      } else if (home?.Content) {
        next(`/content/${home.ID}`)
      } else if (home?.Url) {
        next(home.Url)
      } else {
        next()
      }
    }

  }
  else{
    next('/login')
  }
}

export default homeGuard